<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" *ngIf="errorMessage">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div> -->
        <div class="modal-body p-4 p-md-5">
            <div class="row mx-0">
                <div class="col-12 mb-3 fw-bold" *ngIf="redirection && !nominee">
                    We have identified discrepancy in your application. To resolve the discrepancy click on proceed.
                </div>
                <div class="col-12 fw-bold">
                    {{errorMessage}}
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-center">
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="ModalHide()">{{redirection ? 'Proceed' : 'Okay'}}</button>
        </div>
      </div>
    </div>
  </div>